import { JSResourceForInteraction } from '@atlassian/react-async';
import { createEntryPoint } from '@atlassian/react-entrypoint';

export const createPopupEntryPoint = createEntryPoint({
	root: JSResourceForInteraction(
		() =>
			import(
				/* webpackChunkName: "async-jira-issue-create-modernised-popup" */ './create-popup-content.tsx'
			),
	),
	getPreloadProps: () => ({
		queries: {},
	}),
});
